import { RadialBarChart, RadialBar, ResponsiveContainer, PolarAngleAxis } from 'recharts'
import { Typography } from 'components'

import * as S from './styles'

interface GoalGraphProps {
  percentValue: number
}

export const GoalGraph: React.FC<GoalGraphProps> = ({ percentValue }) => {
  const getFillColor = (value: number) => {
    if (value < 50) return '#FF4842'
    if (value >= 50 && value < 85) return '#FF8D23'
    if (value >= 85 && value < 100) return '#FFC107'
    return '#54D62C'
  }

  const formatValue = (value: number) => {
    return Number(value.toFixed(1))
  }

  return (
    <S.GraphWrapper>
      <S.GraphOverlay>
        <ResponsiveContainer>
          <RadialBarChart
            innerRadius={'85%'}
            outerRadius={'135%'}
            data={[{ value: percentValue, fill: getFillColor(percentValue) }]}
            startAngle={235}
            endAngle={-55}
          >
            <PolarAngleAxis type="number" domain={[0, 100]} tick={false} />
            <RadialBar background dataKey="value" cornerRadius={5} />
          </RadialBarChart>
        </ResponsiveContainer>
      </S.GraphOverlay>
      <S.TextOverlay>
        <Typography design="hav-h5-text" className="display-value">
          {formatValue(percentValue)}%
        </Typography>
        <Typography design="hav-default-04-text">da meta</Typography>
      </S.TextOverlay>
    </S.GraphWrapper>
  )
}
